module.exports = __webpack_public_path__ + "img/111.81dd8095.png";